/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyCategory,
    CompanyCategoryFromJSON,
    CompanyCategoryFromJSONTyped,
    CompanyCategoryToJSON,
} from './CompanyCategory';
import {
    GetCompanyCategoriesResponseAllOf,
    GetCompanyCategoriesResponseAllOfFromJSON,
    GetCompanyCategoriesResponseAllOfFromJSONTyped,
    GetCompanyCategoriesResponseAllOfToJSON,
} from './GetCompanyCategoriesResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetCompanyCategoriesResponse
 */
export interface GetCompanyCategoriesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetCompanyCategoriesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetCompanyCategoriesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<CompanyCategory>}
     * @memberof GetCompanyCategoriesResponse
     */
    data: Array<CompanyCategory>;
}

export function GetCompanyCategoriesResponseFromJSON(json: any): GetCompanyCategoriesResponse {
    return GetCompanyCategoriesResponseFromJSONTyped(json, false);
}

export function GetCompanyCategoriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyCategoriesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(CompanyCategoryFromJSON)),
    };
}

export function GetCompanyCategoriesResponseToJSON(value?: GetCompanyCategoriesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(CompanyCategoryToJSON)),
    };
}

